<template>
  <div id="models">
    <div class="main">
      <div class="search_expand_area">
        <el-button type="text" @click="toggleSearchForm">
          {{$t('cmsg.search')}}
          <i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </div>
      <el-form
        :inline="true"
        :model="searchForm"
        size="mini"
        class="search_form"
        status-icon
        :validate-on-rule-change="false"
        :show-message="false"
      >
        <el-form-item :label="$t('cmsg.name')">
          <el-input v-model="searchForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.type')">
          <el-select v-model="searchForm.model_type" filterable>
            <el-option :label="$t('cmsg.all')" value></el-option>
                        <el-option v-for="i in modelTypeLists" :key="i.keyValue" :label="i.keyName" :value="i.keyValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="default"
            @click="searchSubmit"
            :disabled="tableLoading"
            :loading="tableLoading"
            icon="el-icon-3d-search"
          >{{$t('cmsg.search')}}</el-button>
          <el-button
            type="default"
            @click="onSearchReset"
            icon="el-icon-3d-reset"
          >{{$t('cmsg.reset')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="items" stripe style="width: 100%">
      <el-table-column :label="$t('cmsg.name')">
        <template slot-scope="scope">
          <div>{{$t('cmsg.enName')}}: {{scope.row.Name}}</div>
          <div>{{$t('cmsg.cnName')}}: {{scope.row.CnName}}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('cmsg.property')">
        <template slot-scope="scope">
          {{$t('cmsg.uniqueCode')}}: {{scope.row.Code}}
          <br>
          {{$t('cmsg.modelType')}}: {{scope.row.ModelType}}
          <br>
          <el-popover trigger="hover" placement="top" v-if="scope.row.SNPrefix != ''" width="450">
            <p>
              {{$t('cmsg.order')}}:{{scope.row.OrderNum}}
              <br>
              {{$t('cmsg.seriesNumberRule')}}:
              <br>
              <s-table :tableData="extractSNP(scope.row.SNPrefix)" :title="$t('cmsg.seeMore')"/>
              <!-- {{$t('cmsg.seriesNumberRule')}}: {{extractSNP(scope.row.SNPrefix)}}</p> -->
            </p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{$t('cmsg.seeMore')}}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
        <el-table-column :label="$t('cmsg.action')" width="320">
          <template slot-scope="scope">
            <el-button
              type="default"
              class="case_btn"
              size="mini"
              v-if="perms.indexOf('dentalscan.set_sn_prefix')>-1"
              @click="setSNPrefix(scope.row)"
            >{{$t('cmsg.setSNPrefix')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[5, 10, 50, 100, 200, 300, 400]"
        :page-size="pageInfo.pageSize"
        :page-count="pageInfo.pages"
        layout="prev, pager, next, total, sizes"
        :total="pageInfo.total"
      ></el-pagination>
    <el-dialog :title="$t('cmsg.setSNPrefix')" :visible.sync="sn.visible" :close-on-click-modal="false" :close-on-press-escape="false" class="sn_prefix_form">
      <el-button
        type="text"
        @click="addSNPrefix"
        style="float:right;padding-top:0px;"
      >{{$t('cmsg.add')}}</el-button>
      <span v-html="sn.editData.title"></span>
      <ul>
        <li>{{$t('cmsg.setSNPrefixHint1')}}</li>
        <li>{{$t('cmsg.setSNPrefixHint2')}}</li>
      </ul>
      <hr>
      <div
        v-for="(prefix,index) in sn.editData.items"
        :key="index"
        :index="index"
        :span="16"
        style="margin-bottom: 5px"
      >
        <el-input ref="snp" class="sn_items_input" v-model="prefix.sn_prefix" maxlength="32">
          <el-button slot="append" icon="el-icon-3d-delete" @click="removeSNPrefix(index)"></el-button>
        </el-input>
      </div>
      <hr>
      <div slot="footer">
        <el-button @click="closeSetSNPrefix">{{$t('cmsg.cancel')}}</el-button>
        <el-button type="primary" @click="submitSNPrefix('sn_prefix_form')">{{$t('cmsg.submit')}}</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import sTable from "@/views/user/component/sTable";
export default {
  components: {sTable},
  data() {
    return {
      searchForm: {
        name: "",
        model_type: ""
      },
      modelTypeLists: [],
      sn: {
        visible: false,
        editData: {
          items: [],
          title: "",
          default: "",
          model_code: ""
        }
      }
    };
  },
  methods: {
    addSNPrefix() {
      this.sn.editData.items.unshift({ sn_prefix: "" });
    },
    removeSNPrefix(index) {
      this.sn.editData.items.splice(index, 1);
    },
    setSNPrefix(row) {
      console.log(row);
      this.$confirm(
        this.$t("cmsg.setSNPrefixDesc", {
          name: row.Name,
          SNPrefix: row.SNPrefix
        }),
        this.$t("cmsg.setSNPrefixHint"),
        {
          type: "warning",
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.sn.editData.items = row.SNPrefix.split(",").map(item => {
          return { sn_prefix: item };
        })

        this.sn.editData.title = this.$t("cmsg.setSNPrefixDesc", {
          name: row.Name,
          SNPrefix: row.SNPrefix
        });

        console.log(this.sn.editData.items)

        this.sn.editData.default = row.SNPrefix;
        this.sn.editData.model_code = row.Code;

        this.sn.visible = true;
      });
    },
    resetSNPrefix() {
      Object.assign(this.sn.editData, this.$options.data().sn.editData);
    },
    submitSNPrefix() {
        console.log(this.$refs);
      var newSNP;
      try {
        newSNP = this.$refs.snp.map(item => item.value.trim()).join(",");
      } catch (e) {
        console.log("submitSNPrefix join newSNP err: ", e);
        newSNP = "";
      }
      console.log("submitSNPrefix newSNP: ", newSNP);
      console.log(this.sn.editData.default)

      if (this.sn.editData.default !== newSNP && newSNP !== "") {
        this.$axios.post(`/api/u/device/model/set/sn`, {
            model_code: this.sn.editData.model_code,
            sn_prefix: newSNP
          },{
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            }).then(res => {
              console.log(res);
              this.sn.loading = false;
              if (
                res.status === 200 &&
                res.data &&
                res.data.status === "success"
              ) {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                this.sn.visible = false;
                var t = this;
                setTimeout(function() {
                  t.resetSNPrefix();
                  window.location = t.$router.resolve({
                    name: "models",
                    query: t.$route.query
                  }).href;
                }, 3000);
              } else if (
                res.status === 200 &&
                res.data &&
                res.data.status !== "success"
              ) {
                var ermsg = {};
                try {
                ermsg = JSON.parse(res.data.result);
                }catch(e){
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.sn.errors[erk] = this.$t("cmsg.errField");
                });
                this.sn.err = res.data.result;
              } else if (
                res.status === 400 &&
                res.data &&
                res.data.status !== "success"
              ) {
                var ermsg = {};
                try {
                ermsg = JSON.parse(res.data.result);
                }catch(e){
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.sn.errors[erk] = this.$t("cmsg.errField");
                });
                this.sn.err = res.data.result;
              } else {
                console.log(res);
                this.$message({
                  type: "warning",
                  message: this.$t("cmsg.mting")
                });
              }
            })
            .catch(e => {
              console.log(e);
              this.sn.loading = false;
              this.$message({
                type: "warning",
                message: this.$t("cmsg.mting")
              });
            });
      }
    },
    closeSetSNPrefix() {
      this.sn.visible = false;
    },
    extractSNP(v) {
      return v.replace(new RegExp(",", "gm"), ", ").split(",") || [];
    },
    toggleSearchForm() {
      var el = document.querySelector(".search_form");
      var elBtn = document.querySelector(".search_expand_area .el-icon--right");
      // console.log();
      if (el.style.display === "" || el.style.display === "none") {
        el.style.display = "block";
        elBtn.classList.remove("el-icon-arrow-right");
        elBtn.classList.add("el-icon-arrow-down");
      } else {
        el.style.display = "none";
        elBtn.classList.remove("el-icon-arrow-down");
        elBtn.classList.add("el-icon-arrow-right");
      }
    },
    onSearchReset() {
      console.log(this.$route.query);
      this.searchForm = {
        name: "",
        model_type: ""
      };
    },
    initSearch() {
      var queryObj = this.$route.query;
      if (queryObj["name"]) {
        this.searchForm.name = queryObj["name"];
      }
      if (queryObj["model_type"]) {
        this.searchForm.model_type = queryObj["model_type"];
      }
    },
    searchSubmit() {
      console.log(this.searchForm);
      var queryObj = this.$route.query;
      queryObj["name"] = this.searchForm.name;
      queryObj["model_type"] = this.searchForm.model_type;
      queryObj["page"] = 1;
      console.log(queryObj);
      Object.keys(queryObj).map((k, i) => {
        if (
          queryObj[k] === undefined ||
          queryObj[k] === "" ||
          (k === "page" && queryObj[k] === 1)
        ) {
          delete queryObj[k];
        }
      });
      console.log(queryObj);
      window.location = this.$router.resolve({
        name: "models",
        query: queryObj
      }).href;
    },
    handleSizeChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["pageSize"] = val;
      queryObj["page"] = 1;
      window.location = this.$router.resolve({
        name: "models",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    },
    handleCurrentChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["page"] = val;
      window.location = this.$router.resolve({
        name: "models",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    }
  },
  mounted() {
    // console.log("this.perms: ", this.$store.state.perms);
    // console.log("this.$perms: ", this.$perms);
    this.initSearch();
    // this.setPerm();
    console.log("this.perms: ", this.perms);
    console.log("mounted:",pub.cdnUrl);
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.models")
    };
  },
  async asyncData(context) {
    let pageInfo = { page: 0, pageSize: 50, pages: 0, total: 0 };
    let items = [];
    let perms = [];
    let modelTypeLists = [];
    var activeIndex = "all";
    if (context.req && context.req.query && context.req.query.status) {
      activeIndex = context.req.query.status;
    }
    await context.$axios
      .get("/api/u/device/model/list?device_type=dentalscan", {
        json: true,
        params: context.route.query,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res)
        // var items = [];
        if (res.data.result && Array.isArray(res.data.result)) {
          items = res.data.result;
          pageInfo = res.data.pageInfo;
        }
      })
      .catch(e => {
        console.log(e);
      });
    await context.$axios
      .get("/api/u/settings/r/device_model_type/list", {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res)
        // var items = [];
        if (res.data.result && Array.isArray(res.data.result)) {
          modelTypeLists = res.data.result.map(item => {
                return {
                  keyName: item.KeyValue,
                  keyValue: item.KeyName
                }
              });
        }
      })
      .catch(e => {
        console.log(e);
      });
    await context.$axios
      .get(`/api/u/settings/b/up`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res);
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          perms = res.data.result;
        }
      })
      .catch(e => {
        console.log(e);
      });
    // console.log("perms: ",perms);
    return {
      pageInfo: pageInfo,
      items: items,
      perms: perms,
      modelTypeLists: modelTypeLists,
      tableLoading: false,
      activeIndex: activeIndex
    };
  }
};
</script>
<style lang="scss">
.fileDownPopover {
  .el-button {
    display: block;
    margin-left: 0px;
  }
}
#models {
  .main {
    background-color: #f7f9fb;
    padding: 15px;
    text-align: left;
    .case_nav {
      display: flex;
      overflow: auto;
    }
    .el-menu-item {
      display: inline;
      border-top: 1px solid #e6e6e6;
      border-left: 1px solid #e6e6e6;
    }
    .el-menu-item.is-active {
      background-color: #f3f3f3;
    }
    .el-menu-item:last-of-type {
      border-right: 1px solid #e6e6e6;
    }
    .hidden_delivery {
      display: none;
    }
    .large_preview {
      width: 80%;
    }
    .large_preview .el-message-box__content {
      overflow: auto;
    }
    .el-table__expanded-cell[class*="cell"] {
      padding: 0px 0px 15px 0px;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border-top-width: 0px;
    }
    .case_btn {
      margin-right: 5px;
      margin-bottom: 5px;
      margin-left: 0px !important;
    }
    .search_expand_area {
      display: none;
    }
    .search_form {
      display: block;
    }
    @media screen and (min-width: 1020px) {
      .search_expand_area {
        display: none;
      }
      .search_form {
        display: block;
      }
    }
    .el-table__expanded-cell[class*="cell"] {
      padding-bottom: 0px !important;
    }
    @media screen and (max-width: 1020px) {
      .search_expand_area {
        display: block;
      }
      .search_form {
        display: none;
      }
      .el-menu-item [class^="el-icon-"] {
        margin-right: 0px;
      }
      .el-menu-item:not(.is-active) .dp_title {
        display: none;
        /* display: inline; */
      }
      .is-active .dp_title {
        display: inline;
      }
      .el-menu-item {
        padding: 0 0px 0 5px;
      }
      .el-pager li:not(.active) {
        display: none;
      }
    }
  }
}
</style>
